import { MantineColor } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import s from './withColor.module.scss';

type ColorProps = {
  color?: MantineColor;
  className?: string;
};

export type WithColorProps<P extends Record<any, any>> = P & ColorProps;

export const withColor =
  <P extends Record<any, any>>(
    WrappedComponent: React.ComponentType<Omit<P, 'color'>>,
    defaultColor: MantineColor = 'dark.6',
  ): React.ComponentType<WithColorProps<P>> =>
  ({ color = defaultColor, ...props }) => {
    const colorMod = color.replace('.', '-');

    return <WrappedComponent {...props} className={cn(props?.className, s.root, s[`root_color-${colorMod}`])} />;
  };
